import { Box, styled, Typography } from '@mui/material';

export const BoxContainerStyled = styled(Box)(({ theme }) => ({
  border: `1px solid  ${theme.palette.colors.borderLine}`,
  borderRadius: '5px',
  backgroundColor: theme.palette.colors.secondaryBackground,
  [theme.breakpoints.up('xxl')]: {
    margin: '4px 0 0 0',
    width: '60%',
    height: 351,
  },
  [theme.breakpoints.between('lg', 'xxl')]: {
    margin: '4px 0 0 0',
    width: '60%',
    height: 351,
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const BoxValuesStyled = styled(Box)(() => ({
  display: 'flex',
  marginBottom: '24px',
}));

export const ContainerLeftStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'Column',
  fontSize: '12px',
  fontWeight: 900,
  marginLeft: '16px',
  marginRight: 'auto',
}));

export const LabelHeaderStyled = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 'bold',
  color: theme.palette.colors.mainFocused,
  marginTop: '20px',
  marginLeft: '16px',
  textTransform: 'Uppercase',
}));

export const LabelStyled = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: theme.palette.colors.label,
  marginTop: '16px',
  textTransform: 'Uppercase',
  [theme.breakpoints.up('xxl')]: {
    fontSize: '12px',
  },
  [theme.breakpoints.between('lg', 'xxl')]: {
    fontSize: '10px',
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: '10px',
  },
}));

export const LabelValueStyled = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 500,
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));
